/* import __COLOCATED_TEMPLATE__ from './key-value-component-configs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();